
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    disabled:{required: false}
  }
})
export default class Button extends Vue {    
  imgStyle!: string;
  disabled!: boolean;
  clicked(){
      this.$emit('clicked');
  }

}
